import { Relationship } from "./relationship";
import { IndividualData } from "@models/individuals/individual-data";

export class OfficerRecord {
  relationship: Relationship;
  isSigningContact: boolean;

  constructor(data: Partial<OfficerRecord>) {
    this.relationship = data.relationship!;
    this.isSigningContact = data.isSigningContact ?? false;

    if (this.relationship.individualDataOverride) {
      this.relationship.individualDataOverride = new IndividualData(this.relationship.individualDataOverride);
    }
  }
}
